export default {
  // header
  'develop': 'Develop',
  'representative': 'Representative',
  'resources': 'Resources',
  'maroscan': 'Maro scan',
  'menu': 'menu',
  'close': 'close',

  // footer
  'footer_home': 'Home',
  'footer_about': 'About',
  'footer_ecosystem': 'Ecosystem',
  'footer_developer': 'Developer',
  'footer_media': 'Social media',
  'about_contant4_time1': 'July, 2020',
  'about_contant4_time1_txt1': 'Maro Rebranding',
  'about_contant4_time2': 'June, 2020',
  'about_contant4_time2_txt1': 'WorkBox Launched',
  'about_contant4_time3': 'March, 2020',
  'about_contant4_time3_txt1': 'Over  10,000,000 blocks produced',
  'about_contant4_time4': 'December, 2019',
  'about_contant4_time4_txt1': 'Stablecoin Launched',
  'about_contant4_time5': 'September, 2019',
  'about_contant4_time5_txt1': 'Tigris Protocol Launched',
  'about_contant4_time6': 'August, 2019',
  'about_contant4_time6_txt1': 'Acorn Protocol Beta Launched',
  'about_contant4_time7': 'July, 2019',
  'about_contant4_time7_txt1': 'Slave Network Launched',
  'about_contant4_time8': 'April, 2019',
  'about_contant4_time8_txt1': 'Maro Connect Launched',
  'about_contant4_time9': 'March, 2019',
  'about_contant4_time9_txt1': 'Mainnet Launched',
  'about_contant4_time10': 'August, 2018',
  'about_contant4_time10_txt1': 'Maro Scan Launched',
  'about_contant4_time11': 'January, 2018',
  'about_contant4_time11_txt1': 'Maro Foundation Founded',

  // home
  'content1_txt': 'A secure mobile wallet app you can use manage your assets on the Maro Blockchain seamlessly',
  'content1_download': 'Tải ngay',

  'content2_h3': 'MARO Connect kết nối bạn với MARO',
  'content2_p': 'Với MARO Connect, bạn có thể bỏ phiếu cho Người đại diện, thu thập phần thưởng, chuyển tài sản, thanh toán và hơn thế nữa',
  'content2_h5_1': 'Dễ sử dụng',
  'content2_txt_1': 'Bạn có thể tạo một tài khoản và sử dụng MARO Connect giống như vậy',
  'content2_h5_2': 'An toàn và bảo mật',
  'content2_txt_2': 'Với thiết bị di động đảm bảo, bạn có thể giữ MARO của mình an toàn. Nếu bị mất thiết bị, bạn chỉ cần lấy lại tài khoản của mình bằng Mnemonic Keys hoặc Private Key trên một thiết bị mới',
  'content2_h5_3': 'Giao dịch nhanh chóng',
  'content2_txt_3': 'Maro Blockchain cho phép giao dịch nhanh chóng và đạt thông lượng cao vì nó giải quyết được hiệu ứng tắc nghẽn đã được thấy ​​trên các nền tảng blockchain khác',

  'content3_h3': 'MARO Connect là một ví di động được thiết kế thân thiện với người dùng',
  'content3_p': 'Là một ví di động dễ sử dụng, MARO Connect cho phép bạn lưu trữ tài sản của mình một cách an toàn. Maro Blockchain xây dựng một nền kinh tế mã thông báo bền vững và cơ sở hạ tầng mở cung cấp cho tất cả công dân toàn cầu một phương tiện để kết nối liền mạch với nền kinh tế toàn cầu, từ đó có thêm nhiều cơ hội thịnh vượng',
  'content3_link': 'Xem thêm>'
}



// WEBPACK FOOTER //
// ./src/i18n/vi.js